import React, { useState } from "react";
import "./SendInformation.scss";
import DynaSelectBox from "../../../../A13/DynaView/DynaSelectBox";
import { TrashSVG } from "../../../ChikaExportSvg/ChikaExportSvg";
import { toast } from "react-toastify";

const SendInformation = ({
  sendData,
  setSendData,
  carOptions = [],
  onAddNewDriver,
}) => {
  const [newCar, setNewCar] = useState({
    id_car: "",
    car_name: "",
    pelak: "",
    driver_mobile: "",
  });

  // بروزرسانی خودکار فیلدهای راننده هنگام انتخاب از لیست
  const handleCarChange = (selectedValue) => {
    const car = carOptions.find((c) => c.value === selectedValue);
    if (car) {
      setNewCar({
        id_car: selectedValue,
        car_name: car.car_name || car.label,
        driver_name: car.driver_name,
        pelak: car.pelak,
        driver_mobile: car.mobile,
      });
    }
  };

  // افزودن راننده به لیست راننده‌ها
  const handleAddCar = () => {
    const { id_car } = newCar;
    if (!id_car) {
      toast.error("لطفاً یک راننده انتخاب کنید.");
      return;
    }
    const alreadyAdded = sendData.cars.some((c) => +c.id_car === +id_car);
    if (alreadyAdded) {
      toast.error("این راننده قبلاً اضافه شده است.");
      return;
    }
    setSendData((prev) => ({
      ...prev,
      cars: [...prev.cars, newCar],
    }));
    // ریست کردن فرم انتخاب
    setNewCar({
      id_car: "",
      car_name: "",
      pelak: "",
      driver_mobile: "",
    });
  };

  // حذف راننده از لیست
  const handleDeleteCar = (index) => {
    setSendData((prev) => ({
      ...prev,
      cars: prev.cars.filter((_, i) => i !== index),
    }));
  };

  const handleAddNewDriver = () => {
    if (onAddNewDriver) {
      onAddNewDriver();
    }
  };

  return (
    <div className="send__information">
      <div className="group__flex__conainer">
        <div className="group__flex">
          <DynaSelectBox
            options={carOptions}
            hasFilter={true}
            label="انتخاب راننده"
            className="solid-dyna-input"
            value={newCar.id_car}
            onChange={(data) => handleCarChange(data.value)}
          />
          <button className="add__button" onClick={handleAddCar}>
            افزودن
          </button>
        </div>
        <button className="add__driver__button" onClick={handleAddNewDriver}>
          افزودن راننده جدید
        </button>
      </div>
      <div className="table__section">
        <div className="table__box">
          <ul className="table__header">
            <li className="table__row">
              <div style={{ width: "30%" }} className="table__cell">
                پلاک
              </div>
              <div style={{ width: "30%" }} className="table__cell">
               اطلاعات راننده
              </div>
              <div style={{ width: "30%" }} className="table__cell">
                شماره تماس
              </div>
              <div style={{ width: "10%" }} className="table__cell">
                عملیات
              </div>
            </li>
          </ul>
          <ul className="table__body">
            {sendData.cars.length > 0 ? (
              sendData.cars.map((car, index) => (
                <li key={car.id_car || index} className="table__row">
                  <div style={{ width: "30%" }} className="table__cell">
                    {car.pelak}
                  </div>
                  <div style={{ width: "30%" }} className="table__cell">
                    {car.car_name}
                  </div>
                  <div style={{ width: "30%" }} className="table__cell">
                    {car.driver_mobile}
                  </div>
                  <div
                    style={{ width: "10%" }}
                    className="table__cell operation"
                  >
                    <button
                      className="trash__button"
                      onClick={() => handleDeleteCar(index)}
                    >
                      <TrashSVG />
                    </button>
                  </div>
                </li>
              ))
            ) : (
              <p className="table__empty">اطلاعاتی موجود نیست</p>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SendInformation;
